module.exports = __webpack_public_path__ + "assets/img/courseGq.430add17.png";